"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("../actions/ActionTypes");

var EMPTY_SET = _immutable.default.OrderedSet();

var appIntegrations = function appIntegrations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_SET;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.APP_INTEGRATIONS_RECEIVED:
      return _immutable.default.OrderedSet(action.payload.sort());

    default:
      return state;
  }
};

var _default = appIntegrations;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/appIntegrations.js
// module id = 637
// module chunks = 209 210 211 212